<div class="spinner" *ngIf="showSpinner">
  <mat-spinner></mat-spinner>
</div>
<ng-container *ngIf="detalleComra.payment_method === 'transferencia'">
<div class="seccion-media" *ngIf="!showSpinner && !showError">
  <h2>{{ `¡${detalleComra.name}, gracias por comprar libros en Objetos Personales!`}}</h2>
  <h3>{{ `Tu número de orden de compra es: ${detalleComra._id}` }}</h3>
  <p>{{ `Te dejamos los datos para que puedas hacer la transferencia` }}</p>
  <p>{{ `Santander Rio` }}</p>
  <p>{{ `Titular: María Stegmayer` }}</p>
  <p>{{ `CBU: 0720195688000037237486` }}</p>
  <p>{{ `Alias: objetos.personales` }}</p>
  <p>{{ `Una vez envíes el comprobante de pago a objetospersonales9@gmail.com` }}</p>
  @if (detalleComra.envioCode === 'sucursal1') {
  <p>
    {{ `Te estaremos enviando los datos para que puedas retirar tu pedido al correo ${detalleComra.email}` }}
  </p>
  }
  @if (detalleComra.envioCode === 'envio2') {
  <p>
    {{ `Te estaremos enviando tu pedido por motomensajería a la siguiente dirección: ${detalleComra.direccion}` }}
  </p>
  <p>
    {{ `Nos comunicaremos para coordinar día y horario de entrega` }}
  </p>
  }
  @if (detalleComra.envioCode === 'envio3') {
  <p>
    {{ `Te estaremos enviando tu pedido a la sucursal: ${detalleComra.provincia} - ${detalleComra.sucursal}` }}
  </p>
  }
</div>
</ng-container>
<ng-container *ngIf="detalleComra.payment_method === 'mercadopago'">
<div class="seccion-media" *ngIf="!showSpinner && !showError">
  <h2>{{ `¡${detalleComra.name}, gracias por comprar libros en Objetos Personales!`}}</h2>
  <h3>{{ `Tu número de orden de compra es: ${detalleComra._id}` }}</h3>
  @if (detalleComra.envioCode === 'sucursal1') {
  <p>
    {{ `Te estaremos enviando los datos para que puedas retirar tu pedido al correo ${detalleComra.email}` }}
  </p>
  }
  @if (detalleComra.envioCode === 'envio2') {
  <p>
    {{ `Te estaremos enviando tu pedido por motomensajería a la siguiente dirección: ${detalleComra.direccion}` }}
  </p>
  <p>
    {{ `Nos comunicaremos para coordinar día y horario de entrega` }}
  </p>
  }
  @if (detalleComra.envioCode === 'envio3') {
  <p>
    {{ `Te estaremos enviando tu pedido a la sucursal: ${detalleComra.provincia} - ${detalleComra.sucursal}` }}
  </p>
  }
</div>
</ng-container>
<div class="seccion-media" *ngIf="showError">
  <p>
    Ups, algo salio mal...
  </p>
</div>